import React from 'react';
import PropTypes from 'prop-types';

import { components } from 'react-select';

const Control = ({ children, selectProps, ...props }) => (
  <components.Control {...props}>
    <div className='flex-container row space-between' data-desc={`select__${selectProps.input.name}_control`}>
      {children}
    </div>
  </components.Control>
);

Control.defaultProps = {
  children: null
};

Control.propTypes = {
  children: PropTypes.any,
  selectProps: PropTypes.any.isRequired
};

export default Control;
